export default {
  'menu.pages': 'דפים',
  'menu.features': 'פיצ׳רים',
  'menu.tenants': 'לקוחות',
  'menu.subscriptions': 'מנויים',
  'menu.adminMarketplace': 'שוק',
  'menu.adminMarketplaceFeatures': 'שוק תכונות',
  'menu.schedulers': 'מתזמנים',
  'menu.dashboard': 'לוח מחוונים',
  'menu.home': 'בית',
  'menu.roles': 'תפקידים',
  'menu.profile': 'פרופיל',
  'menu.management': 'ניהול',
  'menu.logout': 'התנתקות',
  'menu.credits': 'קרדיטים',
  'menu.revenue': 'הכנסות',
  'menu.entitlements': 'הרשאות',
};
